import { Injectable } from '@angular/core';
import { WebservicesService } from '../webservices/webservices.service';
import { ConfigService } from "../config/config.service";

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private csrf_token = null;
  constructor(
	private config: ConfigService,
    private webservices: WebservicesService
  ) { }

  	completeAddress = value => {
		let data: any = { search: value, clientapp: this.config.getClientApp() };
		if (this.csrf_token != null) data.csrf_token = this.csrf_token;
		return !!value ? this.webservices.get('geolocation/complete-address', data) : [];
	};

	addressDetails = (id, csrf_token = null) => {
		let data: any = { place_id: id };
		if (csrf_token != null) data.csrf_token = csrf_token;
		return this.webservices.get('geolocation/address-details', data);
	};

  	callGetStatesByCountry(country_code: string) {
		return this.webservices.get('configuration/get-states-by-country', { country: country_code});
	}

	callGetAllCountries() {
		return this.webservices.get('configuration/get-all-countries');
	}

  	callGetFormMetadata() {
		return this.webservices.get('configuration/get-form-metadata');
	}

	setCSRFToken(csrf_token) {
		this.csrf_token = csrf_token;
	}

	callGetAllJobIndustries() {
		return this.webservices.get('configuration/get-all-job-industries');
	  }
	
	  callGetAllJobTitles() {
		return this.webservices.get('configuration/get-all-job-titles');
	  }
}
